/*
 * @Description:
 * @Version: 1.0
 * @Author: changfeng
 * @Date: 2024-03-12 18:13:57
 * @LastEditors: changfeng
 * @LastEditTime: 2024-03-18 14:12:44
 */
import {AnyAction} from "redux";
import {CampaignState} from "@/redux/interface";
import produce from "immer";

const CampaignInfo: CampaignState = {
	campaignInfo: {
		objectiveType: "WEB_CONVERSIONS",
		campaignProductSource: "STORE",
		campaignName: "",
		budgetOptimizeOn: false,
		budgetOptimize: false,
		budgetMode: "BUDGET_MODE_INFINITE",
		budget: 0,

		advId: undefined,
		operationStatus: undefined,
		campaignId: undefined,
	}
};

const Campaign = (state: CampaignState = CampaignInfo, action: AnyAction) =>
	produce(state, draftState => {
		switch (action.type) {
			case "SET_CAMPAIGN_INFO":
				console.log("action.setCampaignInfo", action.campaign);
				draftState.campaignInfo = action.campaign;
				break;

			default:
				return draftState;
		}
	});

export default Campaign;
